import axios from "../axios-auth";

export const wayAssignService = {
    getWayAssignList,
    saveWayAssign,
    getWayAssignDetail
};

function getWayAssignList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromAssignDate) {
        params["fromAssignDate"] = searchParams.fromAssignDate;
    }

    if (searchParams.toAssignDate) {
        params["toAssignDate"] = searchParams.toAssignDate;
    }

    if (searchParams.wayAssignNo) {
        params["wayAssignNo"] = searchParams.wayAssignNo;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    if (searchParams.wayName) {
        params["wayName"] = searchParams.wayName;
    }

    if (searchParams.marketerName) {
        params["marketerName"] = searchParams.marketerName;
    }

    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    return axios.get("/auth/way-assigns", { params });
}

function saveWayAssign(wayAssign) {
    if (!wayAssign.id) {
        // new stockin
        return axios.post("/auth/way-assign", wayAssign);
    } else {
        // edit
        return axios.put("/auth/way-assign", wayAssign);
    }
}

function getWayAssignDetail(id) {
    return axios.get("/auth/way-assign/" + id);
}

